export default __webpack_public_path__ + "static/media/icon_market.1494995a.svg";